const formatCurrency = (amount, isAveragePrice = false) => {
  const value = isAveragePrice ? Math.floor(amount) : amount;
  return new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

const calculatePercentageChange = (current, previous) => {
  if (!previous || previous === 0) return current > 0 ? 100 : 0;
  return ((current - previous) / previous) * 100;
};

const MonthToMonthComparison = ({
  prev_month_stats,
  current_month_stats,
  comparison_name,
  progress_bar_color,
  prev_month,
  showCurrency = false,
}) => {
  console.log(
    "MONTH TO MONTH",
    comparison_name,
    prev_month_stats,
    current_month_stats
  );
  const isAveragePrice = comparison_name?.toLowerCase().includes("average price") || 
                         comparison_name?.toLowerCase().includes("средняя цена");
  return (
    <div className="tw-mb-3">
      <div className="tw-flex tw-justify-between tw-items-center tw-mb-2">
        <span className="tw-text-gray-500 tw-text-sm">{comparison_name}</span>
        <div className="tw-text-right">
          <div className="tw-font-bold tw-text-lg">
            {formatCurrency(current_month_stats, isAveragePrice)}
            {showCurrency && " ₸"}
          </div>
          <div
            className={`tw-text-sm ${
              calculatePercentageChange(
                current_month_stats,
                prev_month_stats
              ) >= 0
                ? "tw-text-green-600"
                : "tw-text-red-600"
            }`}
          >
            {calculatePercentageChange(current_month_stats, prev_month_stats) >=
            0
              ? "↑"
              : "↓"}{" "}
            {Math.abs(
              calculatePercentageChange(current_month_stats, prev_month_stats)
            ).toFixed(1)}
            %
          </div>
        </div>
      </div>
      <div className="tw-w-full tw-bg-gray-200 tw-rounded-full tw-h-2">
        <div
          className={`${progress_bar_color} tw-h-2 tw-rounded-full`}
          style={{
            width: `${Math.min(
              (current_month_stats /
                Math.max(current_month_stats, prev_month_stats)) *
                100,
              100
            )}%`,
          }}
        ></div>
      </div>
      <small className="tw-text-gray-500">
        {prev_month}: {formatCurrency(prev_month_stats, isAveragePrice)}
        {showCurrency && " ₸"}
      </small>
    </div>
  );
};

export default MonthToMonthComparison;
